var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 47.3346V23.3346C26.0003 22.6274 26.2813 21.9491 26.7814 21.449C27.2815 20.9489 27.9597 20.668 28.667 20.668H39.3337C40.0409 20.668 40.7192 20.9489 41.2193 21.449C41.7194 21.9491 42.0003 22.6274 42.0003 23.3346V47.3346M26.0003 47.3346H42.0003M26.0003 47.3346H23.3337C22.6264 47.3346 21.9481 47.0537 21.448 46.5536C20.9479 46.0535 20.667 45.3752 20.667 44.668V36.668C20.667 35.9607 20.9479 35.2824 21.448 34.7824C21.9481 34.2823 22.6264 34.0013 23.3337 34.0013H26.0003M42.0003 47.3346H44.667C45.3742 47.3346 46.0525 47.0537 46.5526 46.5536C47.0527 46.0535 47.3337 45.3752 47.3337 44.668V32.668C47.3337 31.9607 47.0527 31.2824 46.5526 30.7824C46.0525 30.2823 45.3742 30.0013 44.667 30.0013H42.0003M31.3337 26.0013H36.667M31.3337 31.3346H36.667M31.3337 36.668H36.667M31.3337 42.0013H36.667",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.5b7b9a52a1de6a52ea869677b4c91106.svg";
export { ForwardRef as ReactComponent };